import { createGlobalStyle } from 'styled-components'
import './normalize.css'
import './fonts/stylesheet.css'
export const GlobalStyle = createGlobalStyle`
html {
  scroll-behavior: smooth;
}
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: ${p => p.theme.fontFamily};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    &:focus {
      outline: 2px dotted ${({ theme }) => theme.colors.fontColor}!important;
      outline-offset: 5px;
    }
  }

  }
  body {
    font-size: calc(12px + .35vw);
    color: ${p => p.theme.colors.fontColor};
    background-color: ${({ theme }) => theme.colors.background};
    overflow: hidden;
    overflow-y: scroll;
    @media (orientation: portrait) {
      background-attachment: unset;
    }
  }
  ul, ol {
    list-style-position: inside;
    margin-left: 2rem;
    margin-bottom: 1rem;
  }

  path {
    fill: white;
  }

  h1 {
    font-size: 2.8em
  }
  h2 {
    font-size: 2.4em;
  }
  h3 {
    font-size: 2.1em;
  }
  p {
    font-size: 1.4em;
  }

  a {
    color: blue!important;
    font-size: 1em;
  }
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
`

export default GlobalStyle
